import axios from 'axios'; // 引入axios

let baseUrl = 'https://sbp.rarb.cn';
//let baseUrl = 'http://localhost:8080';

const racmBlockRequestInstance = axios.create({
  baseURL: baseUrl, // 根据项目设置 url = base url + request url
  timeout: 10000 // request timeout
});

export default racmBlockRequestInstance;

export function get(url, params) {
  // get封装
  return new Promise((resolve, reject) => {
    racmBlockRequestInstance
      .get(url, {
        params: params
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function post(url, data) {
  // post封装
  return new Promise((resolve, reject) => {
    racmBlockRequestInstance({
      url: url,
      method: 'POST',
      data: data,
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}
